export type RuntimeActionType =
  | 'record.list'
  | 'record.get'
  | 'record.create'
  | 'record.update'
  | 'record.delete'
  | 'runtime.telemetry'
  | 'tool.generate_artifact';

export const resolveRuntimeActionSuccessMessage = (
  action: RuntimeActionType
): string => {
  switch (action) {
    case 'record.list':
      return 'Registros carregados com sucesso.';
    case 'record.get':
      return 'Registro carregado com sucesso.';
    case 'record.create':
      return 'Registro criado com sucesso.';
    case 'record.update':
      return 'Registro atualizado com sucesso.';
    case 'record.delete':
      return 'Registro removido com sucesso.';
    default:
      return 'Ação executada com sucesso.';
  }
};

export const resolveRuntimeActionErrorMessage = (
  action: RuntimeActionType,
  baseMessage: string
): string => {
  switch (action) {
    case 'record.list':
      return `Falha ao listar registros: ${baseMessage}`;
    case 'record.get':
      return `Falha ao carregar registro: ${baseMessage}`;
    case 'record.create':
      return `Falha ao criar registro: ${baseMessage}`;
    case 'record.update':
      return `Falha ao atualizar registro: ${baseMessage}`;
    case 'record.delete':
      return `Falha ao remover registro: ${baseMessage}`;
    default:
      return baseMessage;
  }
};
